import { UserType } from "@/graphql/types";
import { ref } from "vue";

// Singleton instance
let instance: ReturnType<typeof createUserSidebar> | null = null;

function createUserSidebar() {
  const selectedUser = ref<UserType | undefined>();
  const isHiding = ref(false);

  function showUserSidebar(user: UserType) {
    isHiding.value = false;
    selectedUser.value = user;
  }

  function hideUserSidebar() {
    isHiding.value = true;
    requestAnimationFrame(() => {
      setTimeout(() => {
        selectedUser.value = undefined;
        isHiding.value = false;
      }, 400);
    });
  }

  return { selectedUser, showUserSidebar, hideUserSidebar, isHiding };
}

export default function useUserSidebar() {
  if (!instance) {
    instance = createUserSidebar();
  }
  return instance;
}
